export default "__VITE_ASSET__CvbpeYoq__"